package dev.lingvo.shared

import kotlinx.serialization.Serializable

/** Explicit selection prevents a share link from expanding when a design gains more renders. */
@Serializable
data class CreateScreenshotReviewLinkRequest(
    val designVersion: Int,
    val renderIds: List<String>,
    val expiresInHours: Int = 168,
)

/** Admin metadata omits the bearer secret so listing links cannot reconstruct public access. */
@Serializable
data class ScreenshotReviewLinkDto(
    val id: String,
    val designVersion: Int,
    val createdAt: String,
    val expiresAt: String,
    val revokedAt: String? = null,
    val imageCount: Int,
)

/** Returned exactly once; accidental DTO logging must never print the bearer credential. */
@Serializable
data class CreatedScreenshotReviewLinkDto(val link: ScreenshotReviewLinkDto, val token: String) {
    override fun toString(): String = "CreatedScreenshotReviewLinkDto(link=$link, token=[redacted])"
}

/** This intentionally separate surface cannot serialize workspace, design or capture metadata. */
@Serializable
data class ScreenshotPublicReviewDto(val images: List<ScreenshotPublicReviewImageDto>)

/** Captions are plain text; the image id names a copied output, never an original capture. */
@Serializable
data class ScreenshotPublicReviewImageDto(
    val id: String,
    val locale: String,
    val deviceClass: DeviceClass,
    val width: Int,
    val height: Int,
    val caption: String? = null,
)
